import getTextValue from 'src/core/CoreSelectionList/functions/getTextValue'
import type { CoreSelectionListItem } from 'src/core/CoreSelectionList/types'

/**
 * Пункты, в тексте которых есть `searchQuery`.
 * Сортировка: совпадение ближе к началу — выше; при равенстве — короче текст выше.
 */
export default function filterItemsBySearch(
  items: CoreSelectionListItem[],
  searchQuery: string,
  itemText: string,
): CoreSelectionListItem[] {
  const query = searchQuery.toLowerCase()

  return items
    .map(item => ({
      item,
      text: getTextValue(item, itemText).toLowerCase(),
    }))
    .filter(({ text }) => text.includes(query))
    .sort((a, b) => {
      const aIndex = a.text.indexOf(query)
      const bIndex = b.text.indexOf(query)

      return aIndex - bIndex || a.text.length - b.text.length
    })
    .map(({ item }) => item)
}
